import {useTheme} from 'styled-components';
import Button from 'components/common/Button';

import {
  Title,
  SubTitle,
  StyledIcon,
  ButtonsWrapper,
  ShareRegistrationLinkButton,
} from '../styled';
import {useTranslation} from 'react-i18next';
import ChekinProSettings from 'ChekinProSettings';

type Props = {
  loading?: boolean;
  nextPage: string;
};
export function NoGuests({loading, nextPage}: Props) {
  const theme = useTheme();
  const {t} = useTranslation();

  return (
    <>
      <StyledIcon
        name={'iconRegister'}
        color={theme.colors.branding.primary}
        custom
        size={200}
        className="guest-register-view__icon-register"
      />
      <Title className="guest-register-view__no-guests-title">
        {t('no_registered_guest')}
      </Title>
      <SubTitle className="guest-register-view__no-guests-subtitle">
        {t('click_register_guest')}
      </SubTitle>
      <ButtonsWrapper className="guest-register-view__btns">
        <Button loading={loading} label={t('register_guest')} to={nextPage} />
        {ChekinProSettings.canShareRegistrationLink && <ShareRegistrationLinkButton />}
      </ButtonsWrapper>
    </>
  );
}
